import { useActions, useGetters } from 'vuex-composition-helpers';

const useStore = () => {
  const { setUsername } = useActions({
    setUsername: 'GameModule/setUsername',
  });

  const { username } = useGetters({
    username: 'GameModule/getUsername',
  });

  return {
    setUsername,
    username,
  };
};

export default useStore;
